<template>
  <div class="app-bottom-nav-inner bg-white border-t border-gray-200 flex items-center justify-around px-2 shadow-lg select-none">
    <button
      v-for="link in links"
      :key="link.key || link.title"
      type="button"
      @click="navigate(link)"
      class="flex flex-col items-center justify-center flex-1 py-1 px-1 bg-transparent border-none cursor-pointer transition-colors"
      :class="isActive(link) ? 'text-indigo-600' : 'text-gray-400 hover:text-gray-600'"
    >
      <v-icon
        small
        :color="isActive(link) ? '#4f46e5' : '#9ca3af'"
        class="transition-transform duration-150"
        :class="{ 'scale-110': isActive(link) }"
      >
        {{ link.icon }}
      </v-icon>
      <span class="text-[10px] font-bold mt-1 tracking-tight truncate max-w-[64px]">
        {{ link.title }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AppBottomNav',
  props: {
    links: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isActive(link) {
      if (link.to === '/app/dashboard#tasks') {
        return this.$route.path === '/app/dashboard' && this.$route.hash === '#tasks'
      }
      if (link.to === '/app/dashboard') {
        return this.$route.path === '/app/dashboard' && (!this.$route.hash || this.$route.hash !== '#tasks')
      }
      return this.$route.path === link.to
    },
    navigate(link) {
      if (link.to === '/app/dashboard#tasks') {
        if (this.$route.path !== '/app/dashboard') {
          this.$router.push('/app/dashboard').then(() => {
            this.scrollToTasks()
          })
        } else {
          this.scrollToTasks()
        }
        return
      }

      if (this.$route.fullPath !== link.to) {
        this.$router.push(link.to)
      }
    },
    scrollToTasks() {
      if (this.$route.hash !== '#tasks') {
        this.$router.replace({ path: '/app/dashboard', hash: '#tasks' }).catch(() => {})
      }
      this.$nextTick(() => {
        const el = document.getElementById('tasks-schedule-section')
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      })
    }
  }
}
</script>

<style scoped>
.app-bottom-nav-inner {
  height: calc(3.5rem + var(--safe-bottom, 0px));
  padding-bottom: var(--safe-bottom, 0px);
  min-height: 3.5rem;
  box-sizing: border-box;
}
</style>
